import { DocumentCivilStatusDeathUploadCrumbs } from 'civil-status/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormDocumentDeathUploadNew from 'civil-status/components/upload-document-death-form';
import { transformUploadDeathNewPage } from 'civil-status/utils/transform-upload-new-act';
import { DocumentDeathUploadFormVM } from 'civil-status/view-models/document-birth-form';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

export default function DocumentDeathUploadNewPage(): React.ReactElement {
  const insert = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/atti-morte-sima/caricamento-atto-morte/inesistente`,
    {
      options: { method: 'POST', loading: true, errorCatching: true },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: DocumentDeathUploadFormVM | undefined) => {
      const data = transformUploadDeathNewPage(formValues);
      (
        insert({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/morte');
      });
    },
    [insert, navigate]
  );
  return (
    <>
      <Breadcrumbs items={DocumentCivilStatusDeathUploadCrumbs} base="stato-civile" />
      <FormDocumentDeathUploadNew
        title="Caricamento Nuovo Atto"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/stato-civile/matrimonio');
        }}
      />
    </>
  );
}

DocumentDeathUploadNewPage.displayName = 'home page component';
